// 유입 분석 화면 공통 값
export const DAY_MS = 24 * 60 * 60 * 1000;
const KST_OFFSET_MS = 9 * 60 * 60 * 1000;

// 차트 색: dataviz 검증 통과 (방문 파랑 / 클릭 핑크, 흰 배경 대비 3:1 이상, 색각 이상 구분 가능)
export const COLORS = {
    visits: '#3b6fd4',
    clicks: '#d9577a',
    bar: '#d9577a',
};

// 히트맵 단계 (같은 핑크 계열, 연한 → 진한)
export const HEAT_STEPS = ['#f3f4f6', '#fbe4ea', '#f4bccb', '#e98ea7', '#d9577a', '#a8324f'];

export const WEEKDAYS = ['월', '화', '수', '목', '금', '토', '일'];

export const IN_APP_LABELS = {
    instagram: '인스타그램',
    kakaotalk: '카카오톡',
    facebook: '페이스북',
    naver: '네이버 앱',
    line: '라인',
};
export const DEVICE_LABELS = { mobile: '모바일', desktop: 'PC' };

// KST 기준 오늘부터 days 일 전까지
export function getRange(days) {
    const today = new Date(Date.now() + KST_OFFSET_MS);
    const from = new Date(today.getTime() - (days - 1) * DAY_MS);
    return { from: from.toISOString().slice(0, 10), to: today.toISOString().slice(0, 10) };
}

export function formatShortDate(date) {
    return `${Number(date.slice(5, 7))}.${Number(date.slice(8, 10))}`;
}

export function formatNumber(value) {
    return (value || 0).toLocaleString();
}

export function formatPercent(ratio, digits = 1) {
    return ratio === null || ratio === undefined ? '-' : `${(ratio * 100).toFixed(digits)}%`;
}

/**
 * 이전 기간 대비 변화. 이전 값이 0 이면 비율 대신 null.
 */
export function getDelta(current, previous) {
    if (current === null || previous === null || current === undefined || previous === undefined) {
        return null;
    }
    if (!previous) {
        return current ? { ratio: null, direction: 'up' } : { ratio: 0, direction: 'flat' };
    }
    const ratio = (current - previous) / previous;
    return { ratio, direction: ratio > 0.0005 ? 'up' : ratio < -0.0005 ? 'down' : 'flat' };
}
